<template>
  <div>
    <div class="dashboard__wrap">
      <div class="dashboard__manageListing-top">
        <router-link
          :to="`/members?page=${getPages}&currentPage=${curPage}`"
          tag="p"
          class="dashboard__back"
          >Back</router-link
        >
        <div v-if="kycStatus != null" class="dashboard__manageListing-action">
          <button
            class="alt_btn"
            @click="approveMember"
            v-if="kycStatus == 'pending' || kycStatus == 'declined'"
            type="button"
          >
            Approve kyc
          </button>

          <b-dropdown
            id="dropdown-right"
            right
            toggle-class="text-decoration-none alt_btn"
            no-caret
            v-if="kycStatus != 'declined'"
          >
            <template v-slot:button-content class="alt_btn">
              <svgicon
                icon="table-menu"
                class="dashboard__manageListing-action-icon"
              ></svgicon>
            </template>
            <b-dropdown-item-button @click="toggleDisapprovemodal"
              >Decline</b-dropdown-item-button
            >
          </b-dropdown>
        </div>
      </div>
      <p
        class="
          dashboard__manageListing-status
          dashboard__payment-history-table-status
        "
        v-if="kycStatus != null"
        :class="[
          { pending: kycStatus == 'pending' },
          { approve: kycStatus == 'approved' },
          { decline: kycStatus == 'declined' },
          { none: kycStatus == 'none' }
        ]"
      >
        {{ kycStatus | capitalize }}
      </p>
      <div class="dashboard__account-wrap">
        <div class="dashboard__tab dashboard__profile-tab">
          <b-tabs v-model="tabIndex">
            <b-tab title="Profile" active>
              <form action>
                <div class="dashboard__tab-wrap">
                  <div class="dashboard__profile-changeImage">
                    <div class="d-flex align-items-center">
                      <div
                        class="dashboard__profile-image"
                        :style="{
                          backgroundImage: 'url(' + profileImage + ')'
                        }"
                        v-if="profileImage != null"
                      ></div>
                      <div
                        class="dashboard__profile-image"
                        :style="{ backgroundImage: 'url(' + avartar + ')' }"
                        v-if="profileImage == null"
                      ></div>
                    </div>
                  </div>

                  <div class="dashboard__form-group">
                    <div class="form__group">
                      <label for class="form__label">First name</label>
                      <p>{{ fname ? fname : "N/A" }}</p>
                    </div>
                    <div class="form__group">
                      <label for class="form__label">Last name</label>
                      <p>{{ lname ? lname : "N/A" }}</p>
                    </div>
                  </div>

                  <div class="dashboard__form-group">
                    <div class="form__group">
                      <label for class="form__label">Email</label>
                      <p>{{ email ? email : "N/A" }}</p>
                    </div>
                    <div class="form__group">
                      <label for class="form__label">Phone number</label>
                      <p>{{ phone ? phone : "N/A" }}</p>
                    </div>
                  </div>
                  <div class="dashboard__form-group">
                    <div class="form__group">
                      <label for class="form__label">Gender</label>
                      <p>{{ gender ? gender : "N/A" }}</p>
                    </div>
                    <div class="form__group">
                      <label for class="form__label">Date of Birth</label>

                      <p>{{ dob ? dob : "N/A" }}</p>
                    </div>
                  </div>
                </div>
                <p class="dashboard__profile-address-title">Your Address</p>
                <div class="dashboard__tab-wrap">
                  <div class="dashboard__form-group">
                    <div class="form__group">
                      <label for class="form__label">Full address</label>
                      <p>{{ address ? address : "N/A" }}</p>
                    </div>
                    <div class="form__group">
                      <label for class="form__label">Landmark</label>
                      <p>{{ landmark ? landmark : "N/A" }}</p>
                    </div>
                    <div class="form__group">
                      <label for class="form__label">State</label>
                      <p>{{ state ? state : "N/A" }}</p>
                    </div>
                    <div class="form__group">
                      <label for class="form__label">Country</label>
                      <p>{{ country ? country : "N/A" }}</p>
                    </div>
                  </div>
                </div>
              </form>
            </b-tab>
            <b-tab title="Employment Details">
              <form class="dashboard__tab-wrap" action>
                <div class="dashboard__form-group">
                  <div class="form__group">
                    <label for class="form__label">Employment status</label>
                    <p>
                      {{ employmentStatus ? employmentStatus : "N/A" }}
                    </p>
                  </div>
                  <div class="form__group">
                    <label for class="form__label"
                      >Company / Employer’s name</label
                    >
                    <p>
                      {{ employerName ? employerName : "N/A" }}
                    </p>
                  </div>
                </div>
                <div class="dashboard__form-group">
                  <div class="form__group">
                    <label for class="form__label">Monthly income</label>
                    <p>{{ income ? income : "N/A" }}</p>
                  </div>
                  <div class="form__group">
                    <label for class="form__label">Job title</label>
                    <p>{{ jobTitle ? jobTitle : "N/A" }}</p>
                  </div>
                  <div class="form__group">
                    <label for class="form__label">Employer address</label>
                    <p>{{ employerAddress ? employerAddress : "N/A" }}</p>
                  </div>
                </div>
              </form>
            </b-tab>
            <b-tab title="Company">
              <form action>
                <div class="dashboard__tab-wrap">
                  <div class="form__group">
                    <label class="form__label"
                      >Are you listing as a company?</label
                    >
                    <p>{{ asCompany ? asCompany : "No" }}</p>
                  </div>

                  <div class="form__group" v-if="asCompany">
                    <label for class="form__label">Company</label>
                    <p>{{ company ? company : "N/A" }}</p>
                  </div>
                </div>
                <p class="dashboard__profile-address-title">
                  Alternative contact details
                </p>
                <div class="dashboard__tab-wrap">
                  <div class="dashboard__form-group">
                    <div class="form__group">
                      <label for class="form__label">First name</label>
                      <p>{{ altFname ? altFname : "N/A" }}</p>
                    </div>
                    <div class="form__group">
                      <label for class="form__label">Last name</label>
                      <p>{{ altLname ? altLname : "N/A" }}</p>
                    </div>
                  </div>
                  <div class="dashboard__form-group">
                    <div class="form__group">
                      <label for class="form__label">Phone number</label>
                      <p>{{ altPhone ? altPhone : "N/A" }}</p>
                    </div>
                    <div class="form__group">
                      <label for class="form__label">Email</label>
                      <p>{{ altEmail ? altEmail : "N/A" }}</p>
                    </div>
                  </div>
                </div>
              </form>
            </b-tab>
            <b-tab title="Next of Kin">
              <form class="dashboard__tab-wrap" action>
                <div class="dashboard__form-group">
                  <div class="form__group">
                    <label for class="form__label">First name</label>
                    <p>{{ kinFname ? kinFname : "N/A" }}</p>
                  </div>
                  <div class="form__group">
                    <label for class="form__label">Last name</label>
                    <p>{{ kinLname ? kinLname : "N/A" }}</p>
                  </div>
                </div>
                <div class="dashboard__form-group">
                  <div class="form__group">
                    <label for class="form__label">Phone</label>
                    <p>{{ kinPhone ? kinPhone : "N/A" }}</p>
                  </div>
                  <div class="form__group">
                    <label for class="form__label">Email</label>
                    <p>{{ kinEmail ? kinEmail : "N/A" }}</p>
                  </div>
                  <div class="form__group">
                    <label for class="form__label"
                      >Relationship with next of kin</label
                    >
                    <p>{{ kinRelationship ? kinRelationship : "N/A" }}</p>
                  </div>
                </div>
              </form>
            </b-tab>
            <b-tab title="Documents" lazy>
              <div class="dashboard__tab-wrap">
                <form action>
                  <div class="form__group">
                    <label class="form__label"
                      >What means of identification are you uploading?
                      <span
                        class="
                          dashboard__manageListing-status
                          dashboard__payment-history-table-status
                        "
                        :class="[
                          { pending: !autoVerified },
                          { approve: autoVerified }
                        ]"
                        v-if="!autoVerified && kycStatus !== 'approved'"
                      >
                        {{ autoVerified ? "ID verified" : "ID not verified" }}
                      </span>
                    </label>
                    <p>{{ meansOfID ? meansOfID : "N/A" }}</p>
                  </div>
                  <div class="form__group">
                    <label for class="form__label">ID number</label>

                    <p>{{ idNumber ? idNumber : "N/A" }}</p>
                  </div>
                  <div class="dashboard__profile-document">
                    <div class="form__group">
                      <label for class="form__label">ID Image</label>
                      <!-- identificationImage upload -->
                      <div
                        v-if="identificationImageFront"
                        class="dashboard__profile-document-id"
                        :style="{
                          backgroundImage: 'url(' + identificationImageFront + ')'
                        }"
                      >
                        <svgicon
                          icon="attachment"
                          class="dashboard__attachicon"
                          v-if="
                            identificationType == 'pdf' ||
                              identificationType == 'docx' ||
                              identificationType == 'doc'
                          "
                        ></svgicon>
                        <div
                          class="identification__placeholder-wrap"
                          v-show="identificationImageFront == null"
                        >
                          <img
                            src="../../assets/images/identification.svg"
                            class="img-fluid identification__image"
                            v-show="identificationImageFront == null"
                            alt
                          />
                          <p class="identification__image-text">
                            No identification image
                          </p>
                        </div>
                      </div>
                      <div
                        v-if="identificationImageBack"
                        class="dashboard__profile-document-id"
                        :style="{
                          backgroundImage: 'url(' + identificationImageBack + ')'
                        }"
                      >
                        <svgicon
                          icon="attachment"
                          class="dashboard__attachicon"
                          v-if="
                            identificationType == 'pdf' ||
                              identificationType == 'docx' ||
                              identificationType == 'doc'
                          "
                        ></svgicon>
                        <div
                          class="identification__placeholder-wrap"
                          v-show="identificationImageBack == null"
                        >
                          <img
                            src="../../assets/images/identification.svg"
                            class="img-fluid identification__image"
                            v-show="identificationImageBack == null"
                            alt
                          />
                          <p class="identification__image-text">
                            No identification image
                          </p>
                        </div>
                      </div>
                      <p v-else>
                        {{ identificationImageFront ? identificationImageFront : "N/A" }}
                        {{ identificationImageBank ? identificationImageBank : "N/A" }}
                      </p>
                    </div>

                    <div class="form__group">
                      <label for class="form__label">Selfie</label>

                      <div
                        v-if="selfie"
                        class="dashboard__profile-document-selfie"
                        :style="{ backgroundImage: 'url(' + selfie + ')' }"
                      >
                        <div class="selfie__placeholder-wrap">
                          <img
                            src="../../assets/images/selfie.svg"
                            class="img-fluid identification__image"
                            v-show="selfie == null"
                            alt
                          />
                          <p v-if="!selfie" class="identification__image-text">
                            No picture uploaded
                          </p>
                        </div>
                      </div>
                      <p v-else>
                        {{ selfie ? selfie : "N/A" }}
                      </p>
                    </div>
                  </div>
                </form>
              </div>
            </b-tab>
            <b-tab title="Guarantor">
              <form class="dashboard__tab-wrap">
                <div class="dashboard__form-group">
                  <div class="form__group">
                    <label for class="form__label">First name</label>
                    <p>
                      {{ guarFname ? guarFname : "N/A" }}
                    </p>
                  </div>
                  <div class="form__group">
                    <label for class="form__label">Last name</label>
                    <p>
                      {{ guarLname ? guarLname : "N/A" }}
                    </p>
                  </div>
                </div>
                <div class="dashboard__form-group">
                  <div class="form__group">
                    <label for class="form__label">Phone</label>
                    <p>
                      {{ guarPhone ? guarPhone : "N/A" }}
                    </p>
                  </div>
                  <div class="form__group">
                    <label for class="form__label">Email</label>
                    <p>
                      {{ guarEmail ? guarEmail : "N/A" }}
                    </p>
                  </div>
                </div>
                <div class="dashboard__form-group">
                  <div class="form__group">
                    <label for class="form__label">Guarantor occupation</label>
                    <p>
                      {{ guarOccupation ? guarOccupation : "N/A" }}
                    </p>
                  </div>
                  <div class="form__group">
                    <label for class="form__label"
                      >Guarantor's office address</label
                    >
                    <p>
                      {{ guarOfficeAddress ? guarOfficeAddress : "N/A" }}
                    </p>
                  </div>
                </div>
                <div class="dashboard__form-group">
                  <div class="form__group w-100">
                    <label for class="form__label"
                      >Guarantor's home address</label
                    >
                    <p>
                      {{ guarAddress ? guarAddress : "N/A" }}
                    </p>
                  </div>
                </div>
              </form>
            </b-tab>
            <b-tab title="Active subscription" @click="getActiveSub">
              <div
                class="
                  dashboard__payment-history-wrap dashboard__overview-table
                  position-relative
                "
              >
                <table class="dashboard__payment-history-table">
                  <thead>
                    <tr>
                      <th class="dashboard__payment-history-table-heading">
                        Space name
                      </th>
                      <th class="dashboard__payment-history-table-heading">
                        Sub Plan
                      </th>
                      <th class="dashboard__payment-history-table-heading">
                        amount
                      </th>
                      <th class="dashboard__payment-history-table-heading">
                        Status
                      </th>
                      <th class="dashboard__payment-history-table-heading">
                        Created
                      </th>
                      <th class="dashboard__payment-history-table-heading">
                        Start date
                      </th>
                      <th class="dashboard__payment-history-table-heading">
                        Due date
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(subscription, index) in activeSub"
                      :key="index"
                      class="dashboard__table-row"
                    >
                      <td class="dashboard__payment-history-table-data">
                        {{ subscription.space_name }}
                      </td>
                      <td class="dashboard__payment-history-table-data">
                        {{ subscription.sub_plan | capitalize }}
                      </td>
                      <td
                        v-if="subscription.price_template"
                        class="dashboard__payment-history-table-data"
                        v-html="getCurrentAmount(subscription.price_template)"
                      ></td>
                      <td class="dashboard__payment-history-table-data">
                        <span
                          class="dashboard__payment-history-table-status"
                          :class="[
                            { pending: subscription.status == 'pending' },
                            { pending: subscription.status == 'canceled' },
                            { approve: subscription.status == 'active' },
                            { decline: subscription.status == 'expired' },
                            { decline: subscription.status == 'inactive' }
                          ]"
                          >{{ subscription.status | capitalize }}</span
                        >
                      </td>
                      <td class="dashboard__payment-history-table-data">
                        {{ formatDate(subscription.created_at) }}
                      </td>
                      <td class="dashboard__payment-history-table-data">
                        {{ formatDate(subscription.start_date) }}
                      </td>
                      <td class="dashboard__payment-history-table-data">
                        {{ formatDate(subscription.end_date) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <loader :loader="activeSubloader" class="innerLoader"></loader>
              </div>
              <div
                v-show="activeSub.length < 1"
                class="dashboard__payment-history-table-empty"
              >
                No Active Subscription
              </div>
            </b-tab>
            <b-tab title="Payment History" @click="getUserPaymentHistory">
              <div class="dashboard__payment-history position-relative">
                <div class="dashboard__payment-history-wrap position-relative">
                  <table class="dashboard__payment-history-table">
                    <thead>
                      <tr>
                        <th class="dashboard__payment-history-table-heading">
                          Space name
                        </th>
                        <th class="dashboard__payment-history-table-heading">
                          Sub type
                        </th>
                        <th class="dashboard__payment-history-table-heading">
                          Space type
                        </th>
                        <th class="dashboard__payment-history-table-heading">
                          Amount
                        </th>
                        <th class="dashboard__payment-history-table-heading">
                          Date
                        </th>
                        <th class="dashboard__payment-history-table-heading">
                          Invoice
                        </th>
                        <th
                          class="dashboard__payment-history-table-heading"
                        ></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(paymentHistory, index) in paymentHistories"
                        :key="index"
                      >
                        <td class="dashboard__payment-history-table-data">
                          {{ paymentHistory.spaceName }}
                        </td>
                        <td class="dashboard__payment-history-table-data">
                          {{ paymentHistory.subPlan | capitalize }}
                        </td>
                        <td class="dashboard__payment-history-table-data">
                          {{ paymentHistory.spaceType | capitalize }}
                        </td>
                        <td class="dashboard__payment-history-table-data">
                          {{ paymentHistory.currency === "GHS" ? "¢" : "₦" }}
                          {{
                            new Intl.NumberFormat().format(
                              paymentHistory.amount
                            )
                          }}
                        </td>
                        <td class="dashboard__payment-history-table-data">
                          {{ formatDate(paymentHistory.created_at) }}
                        </td>
                        <td class="dashboard__payment-history-table-data">
                          <svgicon
                            icon="view"
                            class="
                              dashboard__payment-history-resp-download-icon
                            "
                            style="cursor: pointer"
                            @click="
                              toggleInvoice(
                                paymentHistory.invoice_id,
                                paymentHistory.subPlan
                              )
                            "
                          ></svgicon>
                        </td>
                        <td class="dashboard__payment-history-table-data">
                          <svgicon
                            @click="generateReport(paymentHistory)"
                            icon="download"
                            style="cursor: pointer"
                            class="
                              dashboard__payment-history-resp-download-icon
                            "
                          ></svgicon>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <loader
                    :loader="paymentHistoryLoader"
                    class="innerLoader"
                  ></loader>
                </div>

                <div
                  class="dashboard__payment-history-resp"
                  v-for="(paymentHistory, index) in paymentHistories"
                  :key="index"
                >
                  <div class="dashboard__payment-history-resp-details">
                    <p class="dashboard__payment-history-resp-name">
                      {{ paymentHistory.spaceName }}
                    </p>
                    <p class="dashboard__payment-history-resp-others">
                      {{ paymentHistory.subPlan | capitalize }} |
                      {{ paymentHistory.spaceType | capitalize }}
                    </p>
                  </div>
                  <div class="dashboard__payment-history-resp-details">
                    <p class="dashboard__payment-history-resp-name">
                      ₦
                      {{
                        new Intl.NumberFormat().format(paymentHistory.amount)
                      }}
                    </p>
                    <p class="dashboard__payment-history-resp-others">
                      {{ formatDate(paymentHistory.created_at) }}
                    </p>
                  </div>

                  <div
                    @click="generateReport(paymentHistory)"
                    class="dashboard__payment-history-resp-download"
                  >
                    <span class="dashboard__payment-history-resp-download-text"
                      >Download receipt</span
                    >
                    <svgicon
                      icon="download"
                      class="dashboard__payment-history-resp-download-icon"
                    ></svgicon>
                  </div>
                </div>
                <div
                  class="dashboard__pagination"
                  v-if="paymentHistories.length > 0"
                >
                  <b-pagination
                    pills
                    v-model="currentPage"
                    :total-rows="paymentHistoryCount"
                    :per-page="pageSize"
                    prev-text="Prev"
                    next-text="Next"
                    first-number
                    last-number
                    @change="handlePagination"
                  ></b-pagination>
                </div>
                <div
                  v-show="paymentHistories.length < 1"
                  class="dashboard__payment-history-table-empty"
                >
                  No Transaction History Found
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
    <!-- Disapprove modal -->
    <div
      class="app-modal"
      :class="[showDisapproveModal ? 'show' : 'hide']"
      @click="showDisapproveModal = false"
    >
      <div class="app-modal-content" @click.stop>
        <p class="warning__title">Decline</p>
        <label for class="form__label"
          >Reason for declining {{ fname }}'s KYC</label
        >
        <div
          class="form__radio-wrap"
          v-for="(reason, index) in returnedDeclineReason"
          :key="index"
        >
          <p-check
            class="form__checkbox p-svg p-curve"
            :name="'reason' + index"
            :value="reason.reasons"
            v-model="selectedReasons"
          >
            <!-- svg path -->
            <svg slot="extra" class="svg svg-icon" viewBox="0 0 20 20">
              <path
                d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                style="stroke: white; fill: white"
              />
            </svg>
            {{ reason.reasons }}
          </p-check>
        </div>
        <div class="form__group w-100">
          <label for class="form__label">Other reasons</label>
          <textarea
            class="listing__textarea mb-0 p-3 w-100"
            v-model="reasonNote"
          ></textarea>
        </div>
        <div class="form__action-wrap">
          <span @click="toggleDisapprovemodal" class="form__back">Cancel</span>
          <button
            class="cta_btn dashboard__btn d-inline"
            @click="declineMember"
            :disabled="
              (selectedReasons.length < 1 && reasonNote == null) ||
                declineLoading
            "
          >
            <svgicon
              v-if="declineLoading"
              icon="spinner"
              class="button__loader"
            ></svgicon>
            Decline
          </button>
        </div>
      </div>
    </div>
    <!-- Disapprove modal -->

    <!-- Invoice modal -->
    <AppModal
      :show="showInvoice"
      @onclosed="showInvoice = false"
      :styleGotten="{ 'max-width': '700px', top: '4%' }"
      v-if="invoice"
    >
      <div class="invoice">
        <img src="../../assets/images/logo.svg" alt="" class="invoice__logo" />
        <div class="invoice__date-wrap">
          <p class="invoice__date-title">Invoice date</p>
          <p class="invoice__date">{{ invoice.created_at | formatDate }}</p>
        </div>

        <div class="invoice__top">
          <div class="invoice__title-wrap">
            <p class="invoice__title">Invoice</p>
            <p class="invoice__for">
              {{ invoice.subPlan | capitalize }} Subscription
            </p>
          </div>
          <div class="invoice__date-wrap">
            <p class="invoice__date-title">Invoice Number</p>
            <p class="invoice__date">{{ invoice.invoiceNumber }}</p>
          </div>
        </div>

        <div class="invoice__action">
          <div class="invoice__to">
            <p class="invoice__to-title">Billed to</p>
            <p class="invoice__to-name">{{ invoice.fullname }}</p>
            <p class="invoice__to-address">
              {{ invoice.fullAddress }}
            </p>
          </div>
        </div>

        <span class="invoice__status" v-if="invoice.paymentStatus === 'success'"
          >Paid</span
        >

        <div class="dashboard__payment-history-wrap invoice__table">
          <table class="dashboard__payment-history-table">
            <thead>
              <tr>
                <th class="dashboard__payment-history-table-heading">
                  Description
                </th>
                <th class="dashboard__payment-history-table-heading">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="dashboard__payment-history-table-data">
                  Rental Subscription
                </td>

                <td class="dashboard__payment-history-table-data">
                  {{ invoice.currency === "GHS" ? "¢" : "₦" }}
                  {{
                    new Intl.NumberFormat().format(
                      Number(invoice.rent) + Number(invoice.commission)
                    )
                  }}
                </td>
              </tr>
              <tr v-if="invoice.booking_fee > 0">
                <td class="dashboard__payment-history-table-data">
                  Booking Fee
                </td>

                <td class="dashboard__payment-history-table-data">
                  {{ invoice.currency === "GHS" ? "¢" : "₦" }}
                  {{
                    new Intl.NumberFormat().format(Number(invoice.booking_fee))
                  }}
                </td>
              </tr>
              <tr v-if="invoice.booking_fee > 0">
                <td class="dashboard__payment-history-table-data">
                  Security Deposit
                </td>

                <td class="dashboard__payment-history-table-data">
                  {{ invoice.currency === "GHS" ? "¢" : "₦" }}
                  {{
                    new Intl.NumberFormat().format(
                      Number(invoice.security_deposit)
                    )
                  }}
                </td>
              </tr>
              <tr>
                <td class="dashboard__payment-history-table-data">
                  Service Charge
                </td>

                <td class="dashboard__payment-history-table-data">
                  {{ invoice.currency === "GHS" ? "¢" : "₦" }}
                  {{
                    new Intl.NumberFormat().format(
                      Number(invoice.service_charge)
                    )
                  }}
                </td>
              </tr>
              <tr
                v-for="(extraCharge, index) in extrachargeInvoice"
                :key="index"
              >
                <td class="dashboard__payment-history-table-data">
                  {{ extraCharge.extrachargeType }}
                </td>

                <td class="dashboard__payment-history-table-data">
                  {{ invoice.currency === "GHS" ? "¢" : "₦" }}
                  {{ new Intl.NumberFormat().format(extraCharge.amount) }}
                </td>
              </tr>
              <tr>
                <td class="dashboard__payment-history-table-data">Discount</td>

                <td class="dashboard__payment-history-table-data">
                  {{ invoice.currency === "GHS" ? "¢" : "₦" }}
                  {{ new Intl.NumberFormat().format(Number(invoice.discount)) }}
                </td>
              </tr>
              <tr>
                <td class="dashboard__payment-history-table-data">
                  VAT (7.5%)
                </td>

                <td class="dashboard__payment-history-table-data">
                  {{ invoice.currency === "GHS" ? "¢" : "₦" }}
                  {{ new Intl.NumberFormat().format(Number(invoice.vat)) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="invoice__total-wrap">
          <p class="invoice__total-title">
            Amount Due {{ invoice.currency === "GHS" ? "GHC" : "NGN" }}
          </p>
          <p class="invoice__total">
            {{ new Intl.NumberFormat().format(invoice.total) }}
          </p>
        </div>
        <p class="invoice__due" v-if="invoice.next_renewal_date">
          Next Due Date: {{ invoice.next_renewal_date | formatDate }}
        </p>
      </div>
    </AppModal>

    <!-- download pdf -->
    <div class="invoice__hide">
      <div class="invoice__content" ref="invoicePDF">
        <div class="invoice" v-if="invoice">
          <img
            src="../../assets/images/logo.svg"
            alt=""
            class="invoice__logo"
          />
          <div class="invoice__date-wrap">
            <p class="invoice__date-title">Invoice date</p>
            <p class="invoice__date">{{ invoice.created_at | formatDate }}</p>
          </div>

          <div class="invoice__top">
            <div class="invoice__title-wrap">
              <p class="invoice__title">Invoice</p>
              <p class="invoice__for">
                {{ invoice.subPlan | capitalize }} Subscription
              </p>
            </div>
            <div class="invoice__date-wrap">
              <p class="invoice__date-title">Invoice Number</p>
              <p class="invoice__date">{{ invoice.invoiceNumber }}</p>
            </div>
          </div>

          <div class="invoice__action">
            <div class="invoice__to">
              <p class="invoice__to-title">Billed to</p>
              <p class="invoice__to-name">{{ invoice.fullname }}</p>
              <p class="invoice__to-address">
                {{ invoice.fullAddress }}
              </p>
            </div>
          </div>

          <span
            class="invoice__status"
            v-if="invoice.paymentStatus === 'success'"
            >Paid</span
          >

          <div class="dashboard__payment-history-wrap invoice__table">
            <table class="dashboard__payment-history-table">
              <thead>
                <tr>
                  <th class="dashboard__payment-history-table-heading">
                    Description
                  </th>
                  <th class="dashboard__payment-history-table-heading">
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="dashboard__payment-history-table-data">
                    Rental Subscription
                  </td>

                  <td class="dashboard__payment-history-table-data">
                    {{ invoice.currency === "GHS" ? "¢" : "₦" }}
                    {{
                      new Intl.NumberFormat().format(
                        Number(invoice.rent) + Number(invoice.commission)
                      )
                    }}
                  </td>
                </tr>
                <tr v-if="invoice.booking_fee > 0">
                  <td class="dashboard__payment-history-table-data">
                    Booking Fee
                  </td>

                  <td class="dashboard__payment-history-table-data">
                    {{ invoice.currency === "GHS" ? "¢" : "₦" }}
                    {{
                      new Intl.NumberFormat().format(
                        Number(invoice.booking_fee)
                      )
                    }}
                  </td>
                </tr>
                <tr v-if="invoice.booking_fee > 0">
                  <td class="dashboard__payment-history-table-data">
                    Security Deposit
                  </td>

                  <td class="dashboard__payment-history-table-data">
                    {{ invoice.currency === "GHS" ? "¢" : "₦" }}
                    {{
                      new Intl.NumberFormat().format(
                        Number(invoice.security_deposit)
                      )
                    }}
                  </td>
                </tr>
                <tr>
                  <td class="dashboard__payment-history-table-data">
                    Service Charge
                  </td>

                  <td class="dashboard__payment-history-table-data">
                    {{ invoice.currency === "GHS" ? "¢" : "₦" }}
                    {{
                      new Intl.NumberFormat().format(
                        Number(invoice.service_charge)
                      )
                    }}
                  </td>
                </tr>
                <tr
                  v-for="(extraCharge, index) in extrachargeInvoice"
                  :key="index"
                >
                  <td class="dashboard__payment-history-table-data">
                    {{ extraCharge.extrachargeType }}
                  </td>

                  <td class="dashboard__payment-history-table-data">
                    {{ invoice.currency === "GHS" ? "¢" : "₦" }}
                    {{ new Intl.NumberFormat().format(extraCharge.amount) }}
                  </td>
                </tr>
                <tr>
                  <td class="dashboard__payment-history-table-data">
                    Discount
                  </td>

                  <td class="dashboard__payment-history-table-data">
                    {{ invoice.currency === "GHS" ? "¢" : "₦" }}
                    {{
                      new Intl.NumberFormat().format(Number(invoice.discount))
                    }}
                  </td>
                </tr>
                <tr>
                  <td class="dashboard__payment-history-table-data">
                    VAT (7.5%)
                  </td>

                  <td class="dashboard__payment-history-table-data">
                    {{ invoice.currency === "GHS" ? "¢" : "₦" }}
                    {{ new Intl.NumberFormat().format(Number(invoice.vat)) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="invoice__total-wrap">
            <p class="invoice__total-title">
              Amount Due {{ invoice.currency === "GHS" ? "GHC" : "NGN" }}
            </p>
            <p class="invoice__total">
              {{ new Intl.NumberFormat().format(invoice.total) }}
            </p>
          </div>
          <p class="invoice__due">
            Next Due Date: {{ invoice.next_renewal_date | formatDate }}
          </p>
        </div>
      </div>
    </div>
    <loader :loader="loader"></loader>
  </div>
</template>

<script>
import { getPaymentInvoice } from "../../../services/invoice";
import {
  getMemberDetails,
  approveMember,
  declineMember,
  getDeclineReason,
  getActiveSub,
  getUserPaymentHistory
} from "../../../services/member";
import { formatReadbleDate, formatCurrencyAmount } from "../../utils/index";
import loader from "../resuables/loader";
import AppModal from "../resuables/modal";
import html2pdf from "html2pdf.js";
import moment from "moment";
export default {
  name: "memberDetail",
  components: {
    loader,
    AppModal
  },
  data() {
    return {
      guarFname: "",
      guarLname: "",
      guarPhone: "",
      guarEmail: "",
      guarAddress: "",
      guarOfficeAddress: "",
      guarOccupation: "",
      reasonNote: null,
      loader: false,
      activeSubloader: false,
      paymentHistoryLoader: false,
      asCompany: null,
      empLoading: false,
      employerName: "",
      jobTitle: null,
      income: "",
      employerAddress: "",
      kinLoading: false,
      kinLname: "",
      kinPhone: "",
      kinFname: "",
      kinEmail: "",
      kinRelationship: null,
      tabIndex: 1,
      deactivateReason: "",
      changingPlatform: false,
      personalReasons: false,
      unableToHost: false,
      safetyIssues: false,
      showDeactivateOptionModal: false,
      showDeactivateModal: false,
      profileImage: null,
      avartar:
        "https://res.cloudinary.com/spleetng/image/upload/v1599653611/avatar.svg",
      fname: "",
      lname: "",
      phone: "",
      phoneAlready: false,
      gender: null,
      dob: "",
      email: "",
      address: "",
      landmark: "",
      state: "",
      country: "",
      company: "",
      employmentStatus: null,
      altFname: "",
      altLname: "",
      altPhone: "",
      altEmail: "",
      identificationModal: false,
      identificationImageFront: null,
      identificationImageBack: null,
      identificationImageFile: null,
      showModal: false,
      selfie: null,
      selfieModal: false,
      camera: null,
      deviceId: null,
      devices: [],
      startCam: false,
      idNumber: "",
      meansOfID: null,
      oldPword: "",
      newPword: "",
      showWarningModal: false,
      spaceNotification: false,
      tips: false,
      marketing: false,
      unsubscribe: false,
      weakPassword: false,
      invalidPassword: false,
      identificationType: null,
      memberId: this.$route.params.id,
      kycStatus: null,
      declineLoading: false,
      showDisapproveModal: false,
      activeSub: [],
      identificationOptions: [
        {
          name: "National ID card",
          value: "national_id"
        },
        {
          name: "Driver’s License",
          value: "driver_license"
        },
        {
          name: "Voter’s card",
          value: "voter"
        },
        {
          name: "International passport",
          value: "passport"
        }
      ],
      returnedDeclineReason: null,
      selectedReasons: [],
      autoVerified: null,
      paymentHistories: [],
      invoice: null,
      extrachargeInvoice: null,
      showInvoice: false,
      pages: 0,
      pageSize: 10,
      currentPage: 1,
      paymentHistoryCount: 0
    };
  },
  computed: {
    getPages() {
      return this.$route.query.page || 0;
    },
    curPage() {
      return this.$route.query.currentPage || 1;
    }
  },
  methods: {
    toggleInvoice(id, subPlan) {
      this.loader = true;
      getPaymentInvoice(id)
        .then(data => {
          this.loader = false;
          if (data.statusCode === 200) {
            let invoice = {
              subPlan: subPlan
            };
            this.invoice = {
              ...invoice,
              ...data.data.subscriptionPayments,
              created_at: moment(invoice.created_at).format("DD-MMM-YYYY")
            };
            this.extrachargeInvoice = data.data.extraChargePayments;
            this.showInvoice = !this.showInvoice;
          }
        })
        .catch(err => {
          this.loader = false;
          return err;
        });
    },
    generateReport(invoice) {
      this.pageLoader = true;
      getPaymentInvoice(invoice.invoice_id)
        .then(data => {
          this.pageLoader = false;
          if (data.statusCode === 200) {
            let subPlan = {
              subPlan: invoice.subPlan
            };
            this.invoice = { ...subPlan, ...data.data.subscriptionPayments };
            this.extrachargeInvoice = data.data.extraChargePayments;
            if (this.invoice) {
              html2pdf(this.$refs.invoicePDF, {
                margin: 0,
                filename: `${this.invoice.invoiceNumber}-${
                  invoice.subPlan
                }-${moment(invoice.created_at).format("DD-MMM-YYYY")}-Inv.pdf`,
                image: { type: "jpeg", quality: 2.3 },
                html2canvas: { scale: 4, scrollX: 0, scrollY: 0 },
                jsPDF: {
                  unit: "in",
                  format: "letter",
                  orientation: "portrait"
                }
              });
            }
          }
        })
        .catch(err => {
          this.pageLoader = false;
          return err;
        });
    },
    addClass() {
      var navWrap = document.querySelector(".nav-tabs");
      navWrap.parentNode.classList.add("dashboard__profile-tab-container");
    },
    toggleDisapprovemodal() {
      this.showDisapproveModal = !this.showDisapproveModal;
      this.selectedReasons = [];
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    approveMember() {
      approveMember(this.memberId)
        .then(data => {
          if (data.statusCode == 200) {
            this.$notification.success({
              message: "Member Approved!",
              description: `You have successfully approved ${this.fname}'s KYC`
            });
            this.getuser();
          } else {
            this.$notification.error({
              message: "Error",
              description: data.data.message
            });
          }
        })
        .catch(err => {
          this.$notification.error({
            message: "Error!",
            description: err.response.data.message
          });
          return err;
        });
    },
    declineMember() {
      this.declineLoading = true;
      let reason;
      if (this.reasonNote == null) {
        reason = {
          declineReasons: this.selectedReasons
        };
      } else {
        this.selectedReasons.push(this.reasonNote);
        reason = {
          declineReasons: this.selectedReasons
        };
      }
      declineMember(this.memberId, reason)
        .then(data => {
          if (data.statusCode == 200) {
            this.declineLoading = false;
            this.showDisapproveModal = false;
            this.reasonNote = null;
            this.selectedReasons = [];
            this.$notification.success({
              message: "Member Declined!",
              description: `You have declined ${this.fname}'s KYC`
            });
            this.getuser();
          } else {
            this.declineLoading = false;
            this.toggleDisapprovemodal();
            this.$notification.error({
              message: "Error",
              description: data.data.message
            });
          }
        })
        .catch(err => {
          this.declineLoading = false;
          this.showDisapproveModal = false;
          this.$notification.error({
            message: "Error!",
            description: err.response.data.message
          });
          return err;
        });
    },
    handlePagination(value) {
      if (value === 1) {
        this.pages = 0;
      } else {
        this.pages = (value - 1) * this.pageSize;
      }
      this.currentPage = value;
      this.getUserPaymentHistory();
    },
    getuser() {
      this.loader = true;
      getMemberDetails(this.memberId)
        .then(data => {
          this.loader = false;
          const userKyc = data.data.kyc;
          const userAlt = data.data.alternativeContact;
          const userEmployment = data.data.employmentDetails;
          const userNextKin = data.data.nextOfKin;
          const guarantor = data.data.guarantor;

          if (data.data.kyc) {
            this.kycStatus = data.data.user.kycStatus;
            this.fname = userKyc.firstname;
            this.lname = userKyc.lastname;
            this.email = data.data.user.email;
            this.autoVerified = userKyc.autoVerified;
            if (userKyc.phone == null) {
              this.phoneAlready = false;
            } else {
              this.phoneAlready = true;
            }
            this.phone = userKyc.phone;
            if (userKyc.dob == null) {
              this.dob = "";
            } else {
              this.dob = moment(userKyc.dob).format("MMM DD, YYYY");
            }
            this.gender = userKyc.gender;
            this.address = userKyc.address;
            this.landmark = userKyc.landmark;
            this.state = userKyc.state;
            this.country = userKyc.country;
            this.profileImage = userKyc.photo;
            this.selfie = userKyc.selfie;
            this.meansOfID = userKyc.identificationType;
            this.identificationImageFront = userKyc.identificationFrontPhotoUrl;
            this.identificationImageBack = userKyc.identificationBackPhotoUrl;
            this.idNumber = userKyc.idNumber;
          }

          if (data.data.alternativeContact) {
            this.altPhone = userAlt.phone;
            this.altEmail = userAlt.email;
            this.altFname = userAlt.firstname;
            this.altLname = userAlt.lastname;
            this.asCompany = userAlt.listingAsCompany;
            this.company = userAlt.companyName;
          }

          if (data.data.employmentDetails) {
            this.employerName = userEmployment.companyName;
            this.employmentStatus = userEmployment.employmentStatus;
            this.employerAddress = userEmployment.companyAddress;
            this.income =
              userEmployment.monthlyIncome === "100000 - 200000"
                ? "less than 200,000"
                : userEmployment.monthlyIncome;
            this.jobTitle = userEmployment.jobTitle;
          }

          if (data.data.nextOfKin) {
            this.kinFname = userNextKin.firstname;
            this.kinLname = userNextKin.lastname;
            this.kinPhone = userNextKin.phone;
            this.kinRelationship = userNextKin.relationship;
            this.kinEmail = userNextKin.email;
          }

          if (data.data.guarantor) {
            this.guarFname = guarantor.firstname;
            this.guarLname = guarantor.lastname;
            this.guarPhone = guarantor.phone;
            this.guarEmail = guarantor.email;
            this.guarAddress = guarantor.address;
            this.guarOfficeAddress = guarantor.officeAddress;
            this.guarOccupation = guarantor.occupation;
          }

          if (data.data.activeUserSubscriptions.length > 0) {
            this.activeSub = data.data.activeUserSubscriptions;
          }
        })
        .catch(err => {
          this.loader = false;
          return err;
        });
    },
    getActiveSub() {
      this.activeSubloader = true;
      getActiveSub(this.memberId)
        .then(data => {
          this.activeSubloader = false;
          if (data.data.memberSubscriptions.length > 0) {
            this.activeSub = data.data.memberSubscriptions;
          }
        })
        .catch(err => {
          this.activeSubloader = false;
          return err;
        });
    },
    getUserPaymentHistory() {
      this.paymentHistoryLoader = true;
      getUserPaymentHistory(this.memberId, this.pages, this.pageSize)
        .then(data => {
          this.paymentHistoryLoader = false;
          this.paymentHistories = data.data.userPayments;
          this.paymentHistoryCount = data.data.totalPayments;
        })
        .catch(err => {
          this.paymentHistoryLoader = false;
          return err;
        });
    },
    getCurrentAmount(price_template) {
      let template = {};
      price_template.map(data => {
        if (data.is_in_use) {
          template = data;
        }
      });
      return formatCurrencyAmount(
        +template.service_charge +
          +template.rent +
          +template.vat +
          +template.security_deposit
      );
    },
    formatDate(date) {
      return formatReadbleDate(date);
    },
    getDeclineReason() {
      getDeclineReason()
        .then(data => {
          this.returnedDeclineReason = data.data;
        })
        .catch(err => {
          return err;
        });
    }
  },
  filters: {
    capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    formatNowDate(value) {
      if (!value) return "";
      if (value) {
        return moment(value).fromNow();
      }
    },
    capitalizeFirstLetter(value) {
      if (!value) return "";
      if (value) {
        return value.charAt(0).toUpperCase() + value.slice(1);
      }
    },
    formatDate(value) {
      if (!value) return "";
      return moment(value).format("DD MMM. YYYY");
    }
  },
  mounted() {
    this.addClass();
    this.getuser();
    this.getDeclineReason();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/memberDetails.vue